import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../../../../store';
import { useParams } from 'react-router-dom';
import { clearSelection, deselectProjectContent, selectAllProjectContents, selectProjectContent } from '../../../../features/sessions/projectsManagement/sessionManageProject';
import './projectContentsSelection.css';

export function ButtonSelectAllUseful() {
  const authHeaders    = useSelector((state: RootState) => state.session.authHeaders);
  const dispatch       = useDispatch<AppDispatch>();
  const selectionCount = useSelector((state: RootState) => state.sessionManageProjectContents.projectContentSelectedList.length);
  const { userNicknameRoute, projectIdRoute } = useParams();

  const selectAllClicked = selectionCount > 0;

  async function handleSelectAll() {
    if (!selectAllClicked && projectIdRoute) {
      await dispatch(selectAllProjectContents({ authHeaders, userNickname: userNicknameRoute, projectId: parseInt(projectIdRoute) }));
    } else {
      dispatch(clearSelection());
    }
  }

  return (
    <div>
      <button
        style={selectAllClicked ? {
          backgroundColor: 'rgb(0, 0, 0)',
          borderRadius: '5px',
          border: 'none',
          justifyContent: 'center',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          cursor: 'pointer',
          boxShadow: '0 0px 0px rgba(0, 0, 0, 0.4)',
        } : {}}
        className="button-select-all-useful-contents"
        onClick={handleSelectAll}
      >
        Select All Useful
      </button>
    </div>
  );
}

export function ProjectContentsSelection({ projectContentId }: any) {
  const authHeaders = useSelector((state: RootState) => state.session.authHeaders);
  const dispatch    = useDispatch<AppDispatch>();
  const { userNicknameRoute } = useParams();

  // Only re-renders when THIS item's selected state changes
  const isSelected = useSelector((state: RootState) =>
    state.sessionManageProjectContents.projectContentSelectedList.includes(projectContentId)
  );

  async function handleSelectProjectContent() {
    if (!isSelected) {
      await dispatch(selectProjectContent({
        authHeaders,
        routeParams: { userNickname: userNicknameRoute, projectContentId },
      }));
    } else {
      dispatch(deselectProjectContent(projectContentId));
    }
  }

  return (
    <div>
      <label className={`checkbox-container ${isSelected ? 'selected' : ''}`}>
        <input
          type='checkbox'
          className='checkbox-button-project'
          onChange={handleSelectProjectContent}
          checked={isSelected}
        />
        <span className='checkmark'></span>
      </label>
    </div>
  );
}
